module.exports = __webpack_public_path__ + "media/images/logo-email-8029222a4c2f2da7345a09c3f96262c6.png";